function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/helpers/arrayLikeToArray.js
// module id = 347
// module chunks = 0